// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, { Input } from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
// import "./assets/css/main.css";
// import './style.scss';
import "./assets/icon/iconfont.css";

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'

import 'video.js/dist/video-js.css' //引入videocss
// 打印引入
// import vueToPdf from 'vue-to-pdf';
// import VueEasyPrinter from 'vue-easy-printer';
// Vue.use(vueToPdf);
// Vue.use(VueEasyPrinter);

import Print from './utis/print';
Vue.use(Print) // 注册
// Vue.use(VueDirectiveImagePreviewer)
Vue.use(ElementUI) //使用elementUI
Vue.config.productionTip = false
Vue.use(VueDirectiveImagePreviewer, {
  zIndex: 9999, //层级显示
  // previewSize: 2 //放大倍数


})
import global from './utis/toTop';// 引入
Vue.prototype.global = global;// 添加


import md5 from 'js-md5'
Vue.prototype.$md5 = md5;

import axios from 'axios';
Vue.prototype.$axios = axios;
import VueAxios from 'vue-axios'
axios.defaults.baseURL = "https://gps.trackline.cn:1027";
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json';
Vue.use(VueAxios, axios)

// Vue.http.headers.common['Cookie'] = 'JSESSIONID=89f159e9-ff67-42ca-bdbc-71d5e03983cc';

// 配置公共数据
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


// 高德地图引入
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: 'dab1e92304949330401621416ef32082',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.Driving', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4',
//   "globals": {
//         "AMap": "true",
//         "AMapUI":"true",
//     }
// })


VueAMap.initAMapApiLoader({
  key: 'dab1e92304949330401621416ef32082',
  plugin: [//高德地图扩展插件(按需添加)
    'AMap.Autocomplete', // 输入提示插件
    'AMap.Geocoder',
    'AMap.PlaceSearch', // POI搜索插件
    'AMap.Scale', // 右下角缩略图插件 比例尺
    'AMap.OverView', // 地图鹰眼插件
    'AMap.ToolBar', // 地图工具条
    'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    'AMap.PolyEditor', // 编辑 折线多，边形
    'AMap.CircleEditor', // 圆形编辑器插件
    'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
    'AMap.Driving', 
  ],
  uiVersion: '1.1', // ui库版本，不配置不加载,

})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js